import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DateService {
    public formatDate(date: string): string {
        return new Date(date).toLocaleString();
    }
}
